import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import GSGallery from "./component";
import { setGsGalleryData } from "../car-details/actions";

const mapStateToProps = ({
    carDetails: {
        content,
        galleryProps: {
            isOpen,
            selectedImageIndex,
            activeTab,
            showGallery
        },
        config: {
            imageHost
        }
    }
}) => ({
    content,
    isOpen,
    activeTab,
    showGallery,
    imageHost,
    selectedImageIndex
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setGsGalleryDataConnect: setGsGalleryData
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(GSGallery);
